import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import { UtenteAdapter } from '../../components/profili-utente/utente-update/utente-adapter';
import { TemplateProfiloResponse } from '../../models/dto/template-profilo-response';
import { TemplatesProfiloResponse } from '../../models/dto/templates-profilo-response';
import { TemplateUtenteProfilo } from '../../models/profili-utente/template-utente-profilo';
import { UtenteProfilo } from '../../models/profili-utente/utente-profilo';
import { UtenteProfiloTemplate } from '../../models/profili-utente/utente-profilo-template';
import { FormValidationService } from '../../services/form-validation.service';
import { BaseForm } from '../base-Form';

declare var removeEmptyObject: any;

export abstract class UtenteForm extends BaseForm {
  utenteForm: FormGroup;
  request: UtenteProfilo;
  listaTemplateUtente: TemplateUtenteProfilo[];
  templateUtente: TemplateUtenteProfilo;
  urlGetTemplates: string;
  urlGetTemplate: string;

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService, private formValidationService: FormValidationService) {
    super();
  }

  createForm() {
    this.request = new UtenteAdapter(this.getUtente()).utente;
    if (this.request.pec && this.request.pec.trim().length === 0) {
      this.request.pec = null;
    }
    this.templateUtente = null;

    this.utenteForm = this.campiForm.group({
      nome: [this.request.nome, Validators.required],
      cognome: [this.request.cognome, Validators.required],
      codiceFiscale: [this.request.codiceFiscale, [Validators.required, Validators.compose([this.formValidationService.codiceFiscale])]],
      username: [this.request.username, Validators.required],
      email: [this.request.email, [Validators.required, Validators.compose([this.formValidationService.email])]],
      pec: [this.request.pec, Validators.compose([this.formValidationService.email])],
      templateProfilo: [this.templateUtente, this.inserimento ? Validators.required : null]
    });
  }

  update() {
       this.getRequest(new UtenteProfiloTemplate(this.request, this.templateUtente));
  }

  populateSelect() {
    if (!this.listaTemplateUtente || (this.listaTemplateUtente && this.listaTemplateUtente.length === 0)) {
      this.operationService.getTemplatesUtente(this.urlGetTemplates).subscribe(response => this.datiTemplatesUtente(response));
    }
  }

  forceTemplate(templateUtente: TemplateUtenteProfilo) {
    this.templateUtente = templateUtente;
  }

  datiTemplatesUtente(response: TemplatesProfiloResponse) {
    if (response.returnCode === 'OK') {
      this.listaTemplateUtente = response.templateProfili;
    }
  }

  datiTemplateUtente(response: TemplateProfiloResponse) {
    if (response.returnCode === 'OK') {
      this.templateUtente = response.templateProfilo;
    }
  }

  onChangeTemplate(templateUtenteId: string) {
    this.templateUtente = null;
    this.operationService.getTemplateUtente(this.urlGetTemplate, templateUtenteId).subscribe(response => this.datiTemplateUtente(response));
  }

  abstract getUtente(): UtenteProfilo;
  abstract getRequest(request: UtenteProfiloTemplate);
}
